import React from 'react';
import MainContent from './MainContent';
import Footer from '../About/Footer';
import Navbar from '../About/Navbar';
import { cn } from '@/lib/utils';

function JdCreation() {
  return (
    <div className={cn("min-h-screen w-full bg-background flex flex-col")}>
      <Navbar />
      <MainContent />
      <Footer />
    </div>
  );
}

export default JdCreation;